module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8019.847aea3c.png";